import * as React from 'react';
import { FlowType } from '../../../../services/userflow/UserFlowService';
import { OneTimeCodePage } from '../../pages/one-time-code/OneTimeCodePage';
import { ErrorFlow } from '../../pages/error/ErrorFlow';
import { ROUTES } from '../../../../Routes';
import PageConfig from '../../../../services/userflow/PageConfig';
import { navigateToErrorPageFromRegister } from '../../pages/error/ErrorNavigation';

interface RegisterOneTimeCodePageProps {
  history: any;
}

const config = {
  startRoute: ROUTES.REGISTER_ENTER_USERNAME,
  errorType: ErrorFlow.register,
  analytics: { pageName: 'register-otc', taskName: 'my-account-registration' },
} as PageConfig;

const RegisterOneTimeCodePage: React.FC<RegisterOneTimeCodePageProps> = ({ history }) => (
  <OneTimeCodePage
    history={history}
    flow={FlowType.register}
    config={config}
    navigateToErrorPage={navigateToErrorPageFromRegister(history)}
    showChangeEmailLink={false}
  />
);

export { RegisterOneTimeCodePage };
